import CashClosingSkeleton from '../CashStatus/CashClosingSkeleton';
import EmptyCashSessionState from '../CashStatus/EmptyCashSessionState';
import CashClosingXFooter from './CashClosingXFooter';
import CashClosingXHeader from './CashClosingXHeader';
import CashClosingXMain from './CashClosingXMain';

interface Props {
  report: any;
  loading: boolean;
  printPending?: boolean;

  onGenerate?: () => void;

  onPrintTicket?: () => void;
  onDownloadPdf?: () => void;
}

const CashClosingXDashboard: React.FC<Props> = ({
  report,
  loading,
  printPending,
  onGenerate,
  onPrintTicket,
  onDownloadPdf,
}) => {
  /**
   * 🔄 Loading
   */
  if (loading) {
    return <CashClosingSkeleton />;
  }

  /**
   * ❌ Sin datos
   */
  if (!report) {
    return <EmptyCashSessionState />;
  }

  return (
    <div
      className="
        rounded-sm border border-stroke bg-white shadow-default
        dark:border-strokedark dark:bg-boxdark
      "
    >
      {/* 🔹 HEADER */}

      <CashClosingXHeader
        report={report}
        loading={loading}
        printPending={printPending}
        onGenerate={onGenerate}
        onPrintTicket={onPrintTicket}
        onDownloadPdf={onDownloadPdf}
      />

      {/* 🔹 MAIN */}

      <CashClosingXMain report={report} />

      {/* 🔹 FOOTER */}

      <CashClosingXFooter data={report} />
    </div>
  );
};

export default CashClosingXDashboard;
